import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const StairOnlyIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "StairOnlyIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M7.54346 15.4189C6.5742 15.4189 5.78564 16.2075 5.78564 17.1768C5.78564 18.146 6.5742 18.9346 7.54346 18.9346C8.51272 18.9346 9.30128 18.146 9.30128 17.1768C9.30128 16.2075 8.51272 15.4189 7.54346 15.4189ZM7.54346 17.7627C7.22037 17.7627 6.95752 17.4998 6.95752 17.1768C6.95752 16.8537 7.22037 16.5908 7.54346 16.5908C7.86655 16.5908 8.1294 16.8537 8.1294 17.1768C8.1294 17.4998 7.86655 17.7627 7.54346 17.7627Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.6841 19.7159H19.8444C19.6416 19.0016 19.0781 18.4381 18.3638 18.2352V13.6612C18.3638 12.6919 17.5752 11.9033 16.606 11.9033H15.2388V9.95021H16.2153C16.5389 9.95021 16.8013 9.68787 16.8013 9.36427V7.02052C16.8013 6.69693 16.5389 6.43458 16.2153 6.43458H8.12941V4.59864C8.12941 3.41399 7.16562 2.4502 5.98097 2.4502H4.80909C4.4855 2.4502 4.22315 2.71254 4.22315 3.03614C4.22315 3.35974 4.48549 3.62208 4.80909 3.62208H5.98097C6.51945 3.62208 6.95753 4.06017 6.95753 4.59864V11.9361C4.32448 12.2285 2.27002 14.467 2.27002 17.1768C2.27002 20.0846 4.63569 22.4502 7.54347 22.4502C10.4512 22.4502 12.8169 20.0846 12.8169 17.1768C12.8169 16.5606 12.7104 15.969 12.5153 15.419H17.1919V18.2352C16.2913 18.491 15.6294 19.3203 15.6294 20.3018C15.6294 21.4864 16.5932 22.4502 17.7779 22.4502C18.7594 22.4502 19.5886 21.7884 19.8444 20.8877H21.6841C22.0077 20.8877 22.2701 20.6254 22.2701 20.3018C22.2701 19.9782 22.0077 19.7159 21.6841 19.7159ZM8.12941 7.60646H15.6294V8.77834H8.12941V7.60646ZM8.12941 9.95021H14.0669V11.9033H8.12941V9.95021ZM7.54347 21.2783C5.28186 21.2783 3.4419 19.4384 3.4419 17.1768C3.4419 14.9152 5.28186 13.0752 7.54347 13.0752C9.80508 13.0752 11.645 14.9152 11.645 17.1768C11.645 19.4384 9.80508 21.2783 7.54347 21.2783ZM11.9261 14.2471C11.6293 13.8046 11.2672 13.4094 10.8539 13.0752H16.606C16.9291 13.0752 17.1919 13.3381 17.1919 13.6611V14.2471H11.9261ZM17.7779 21.2783C17.2394 21.2783 16.8013 20.8403 16.8013 20.3018C16.8013 19.7633 17.2394 19.3252 17.7779 19.3252C18.3163 19.3252 18.7544 19.7633 18.7544 20.3018C18.7544 20.8403 18.3163 21.2783 17.7779 21.2783Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default StairOnlyIcon;
